
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"productDetail"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"deliveryMethod"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"daysBeforePickup"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"scanMoments"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"accessory"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":124}};
    doc.loc.source = {"body":"fragment productDetail on Product {\n    id\n    name\n    deliveryMethod\n    daysBeforePickup\n    scanMoments\n    accessory\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    
